<!--
 * www.cloudscope.cn
 * Copyright (c) 2019. All Rights Reserved.
-->
<!--
 * @Author: liuchang
 * @Date: 2019-08-14 11:57:16
 * @Description: 添加角色弹窗
-->
<template>
    <!-- 添加角色 Dialog: Begin -->
    <el-dialog
        :title="addTitle"
        :visible.sync="dialogVisible"
        custom-class="mod-dialog"
        append-to-body
        @close="close"
        width="500px"
    >
        <div class="main-contain">
            <div class="main-contain">
                <el-form ref="RoleForm" v-model="RoleForm" class="mod-dialog-form" label-width="40px">
                    <el-form-item label="名称">
                        <el-input v-model="RoleForm.name" placeholder="输入名称"></el-input>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button size="mini" style="width:72px" type="info" @click="close">取消</el-button>
            <el-button
                size="mini"
                style="width:72px"
                type="primary"
                @click="addRole"
                v-show="isAdd"
            >添加</el-button>
            <el-button
                size="mini"
                style="width:72px"
                type="primary"
                @click="updateRole"
                v-show="isUpdate"
            >修改</el-button>
        </span>
    </el-dialog>
    <!-- 添加角色 Dialog: End -->
</template>

<script>
export default {
    components: {},
    props: ['addTitle'],
    data () {
        return {
            RoleForm: {
                id: '',
                name: '',
                code: '001',
                status: 1
            },
            dialogVisible: false,
            isAdd: true,
            isUpdate: false
        };
    },
    mounted () {},
    methods: {
        /**
         * @author: liuc
         * @description:关闭弹窗
         * @param {}
         */
        close () {
            this.dialogVisible = false;
            this.RoleForm = {
                id: '',
                name: '',
                code: '001',
                status: 1
            };
            this.$emit('hideDialog');
        },
        /**
         * @author: liuc
         * @description:打开弹窗，判断是“新增”还是“编辑”
         * @param {type} 弹窗类型
         * @param {id} 数据id
         */
        async open (type, id) {
            // 编辑弹窗
            if (type == 1) {
                this.queryRoleById(id);
                this.isAdd = false;
                this.isUpdate = true;
            } else {
                // 新增弹窗
                this.isAdd = true;
                this.isUpdate = false;
            }
            this.dialogVisible = true;
        },
        /**
         * @author: liuc
         * @description:新增角色
         * @param {}
         */
        async addRole () {
            if (!this.RoleForm.name) {
                this.$message.error('角色名称为空');
                return;
            }
            if (
                this.RoleForm.name.length < 2 ||
                this.RoleForm.name.length > 64
            ) {
                this.$message.error('角色名应为2-64位');
                return;
            }
            let result = await this.verifyName(this.RoleForm.name);
            if (result) {
                let response = await this.$api.RoleManagement.addRole(
                    this.RoleForm
                );
                if (response.code == 200) {
                    this.$message.success('添加成功');
                    this.close();
                    this.$emit('loadTableRefresh');
                }
            }
        },
        /**
         * @author: liuc
         * @description: 根据id查找角色
         * @param {id} 角色id
         */
        async queryRoleById (id) {
            let response = await this.$api.RoleManagement.queryRoleById({
                id: id
            });
            this.RoleForm = response.data;
        },
        /**
         * @author: liuc
         * @description: 更新角色信息
         * @param {}
         */
        async updateRole () {
            if (!this.RoleForm.name) {
                this.$message.error('角色名称为空');
                return;
            }
            let result = await this.verifyName(this.RoleForm.name);
            if (result) {
                let response = await this.$api.RoleManagement.updateRoleById(
                    this.RoleForm
                );
                if (response.code == 200) {
                    this.$message.success('修改成功');
                    this.close();
                    this.$emit('loadTableRefresh');
                }
            }
        },
        /**
         * @author: liuc
         * @description: 查询name是否重复
         * @param {name} 信息
         */
        async verifyName (name) {
            if (this.isNotNull(name)) {
                let nameData = {
                    name: name,
                    id: this.RoleForm.id == undefined ? '' : this.RoleForm.id
                };
                let response = await this.$api.RoleManagement.roleVerifyName(
                    nameData
                );
                if (response.data) {
                    return true;
                } else {
                    this.$message.error('角色名称已存在。');
                }
            }
            return false;
        },
        /**
         * @author: liuc
         * @description: 判断传入的值是否为空
         * @param {target} 传入内容
         */
        isNotNull (target) {
            if (target) {
                return true;
            } else {
                return false;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// ./src/components/RoleManagement/Add.vue